import { parseISO } from 'date-fns';

const toInvitee = (raw)=>{
    if (!raw) {
        return undefined;
    }
    var _lastName, _email, _phone;
    return {
        firstName: raw.firstName,
        lastName: (_lastName = raw.lastName) !== null && _lastName !== void 0 ? _lastName : undefined,
        email: (_email = raw.email) !== null && _email !== void 0 ? _email : undefined,
        phone: (_phone = raw.phone) !== null && _phone !== void 0 ? _phone : undefined
    };
};
const toChild = (raw)=>{
    if (!raw) {
        return undefined;
    }
    var _lastName;
    return {
        firstName: raw.firstName,
        lastName: (_lastName = raw.lastName) !== null && _lastName !== void 0 ? _lastName : undefined
    };
};
const toStore = (raw)=>{
    if (!raw) {
        return null;
    }
    var _phone, _streetNumber, _postalCode, _lat, _lon;
    return {
        name: raw.name,
        code: raw.code.toString(),
        phone: (_phone = raw.phone) !== null && _phone !== void 0 ? _phone : null,
        streetName: raw.streetName,
        streetNumber: (_streetNumber = raw.streetNumber) !== null && _streetNumber !== void 0 ? _streetNumber : undefined,
        town: raw.town,
        postalCode: (_postalCode = raw.postalCode) !== null && _postalCode !== void 0 ? _postalCode : undefined,
        country: raw.country,
        lat: (_lat = raw.lat) !== null && _lat !== void 0 ? _lat : undefined,
        lon: (_lon = raw.lon) !== null && _lon !== void 0 ? _lon : undefined
    };
};
const toAppointmentType = (raw)=>{
    if (!raw) {
        return null;
    }
    return {
        name: raw.name,
        label: raw.label,
        description: raw.description,
        duration: raw.duration
    };
};
const toAppointmentTypeDetails = (raw)=>{
    if (!raw) {
        return null;
    }
    return {
        id: raw.id,
        name: raw.name,
        description: raw.description,
        ageGroup: raw.ageGroup
    };
};
const toAppointment = (raw)=>{
    if (!raw) {
        return null;
    }
    var ref8, ref5, ref6, _isReservation1, ref7, _customerComment1;
    return {
        id: raw.id,
        appointmentType: (ref8 = toAppointmentTypeDetails(raw.appointmentType)) !== null && ref8 !== void 0 ? ref8 : undefined,
        invitee: (ref5 = toInvitee(raw.invitee)) !== null && ref5 !== void 0 ? ref5 : undefined,
        child: (ref6 = toChild(raw.child)) !== null && ref6 !== void 0 ? ref6 : undefined,
        isCancellable: raw.isCancellable,
        isReschedulable: raw.isReschedulable,
        isReservation: (_isReservation1 = raw.isReservation) !== null && _isReservation1 !== void 0 ? _isReservation1 : undefined,
        endTime: parseISO(raw.endTime),
        startTime: parseISO(raw.startTime),
        store: (ref7 = toStore(raw.storeInfo)) !== null && ref7 !== void 0 ? ref7 : undefined,
        customerComment: (_customerComment1 = raw.customerComment) !== null && _customerComment1 !== void 0 ? _customerComment1 : undefined
    };
};
var _customerComment, ref, ref1, _isReservation, ref2, _isVirtualAppointment, ref3, ref4;
const toAppointments = (raw)=>{
    return (ref4 = raw === null || raw === void 0 ? void 0 : raw.map((rawAppointment)=>({
            id: rawAppointment.id,
            customerComment: (_customerComment = rawAppointment.customerComment) !== null && _customerComment !== void 0 ? _customerComment : undefined,
            appointmentType: (ref = toAppointmentType(rawAppointment.appointmentType)) !== null && ref !== void 0 ? ref : undefined,
            invitee: (ref1 = toInvitee(rawAppointment.invitee)) !== null && ref1 !== void 0 ? ref1 : undefined,
            isReservation: (_isReservation = rawAppointment.isReservation) !== null && _isReservation !== void 0 ? _isReservation : undefined,
            endTime: parseISO(rawAppointment.endTime),
            startTime: parseISO(rawAppointment.startTime),
            store: (ref2 = toStore(rawAppointment.storeInfo)) !== null && ref2 !== void 0 ? ref2 : undefined,
            isVirtualAppointment: (_isVirtualAppointment = rawAppointment.isVirtualAppointment) !== null && _isVirtualAppointment !== void 0 ? _isVirtualAppointment : false,
            child: (ref3 = toChild(rawAppointment.child)) !== null && ref3 !== void 0 ? ref3 : undefined
        })
    )) !== null && ref4 !== void 0 ? ref4 : null;
};

export { toAppointment, toAppointments };
//# sourceMappingURL=appointment.js.map
